import React from 'react'

import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  startLocation?: string | null
  typeOfExperience?: string
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocationWithTypeOfExperience({
  startLocation,
  typeOfExperience,
  size = 'large',
}: Props) {
  return (
    <CaptionTextBlock variant={size} lineClamp={2}>
      {startLocation}
      {typeOfExperience && (
        <Caption as="span" variant={size} colour="neutral-two">
          {` · ${typeOfExperience}`}
        </Caption>
      )}
    </CaptionTextBlock>
  )
}

export default BookmarkLocationWithTypeOfExperience
